import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { useIsMobile } from '@wix/core-domain-search';
import { ExperimentSpecs } from '../constants';
export const useWhoisMobileOptimizations = () => {
  var _getPremiumEssentials;
  const isMobile = useIsMobile();
  const isSpecOn = Boolean((_getPremiumEssentials = getPremiumEssentialsSafe()) == null || (_getPremiumEssentials = _getPremiumEssentials.experiments) == null ? void 0 : _getPremiumEssentials[ExperimentSpecs.WhoisMobileOptimizations]);
  return isMobile && isSpecOn;
};
//# sourceMappingURL=useWhoisMobileOptimizations.js.map